<div style="float: right;">
    <mat-icon style="cursor: pointer;" (click)="closeModal()">close</mat-icon>
</div>
<div class="page-content" [innerHTML]="message"></div>